import ReactPlayer from 'react-player';

const VideoPlayer = ({ url, controls = true, ...rest }) => {
  return (
    <div
      style={{
        position: 'relative',
        paddingTop: '56.25%',
        width: '100%',
        borderRadius: '8px',
        overflow: 'hidden',
      }}
    >
      <ReactPlayer
        url={url}
        controls={controls}
        width="100%"
        height="100%"
        style={{ position: 'absolute', top: 0, left: 0, borderRadius: '8px', objectFit: 'cover' }}
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
              onContextMenu: (e) => e.preventDefault(),
              preload: 'metadata',
              style: {
                objectFit: 'cover',
                width: '100%',
                height: '100%',
              },
            },
          },
        }}
        {...rest}
      />
    </div>
  );
};

export default VideoPlayer;
